import { render, staticRenderFns } from "./OrganisationDetailForm.vue?vue&type=template&id=f71df35a&"
import script from "./OrganisationDetailForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports